import React from 'react'
import { CurFormatComponent } from '../../shared/cur_format/cur_format.component'

export class ItemPriceConditionsComponent extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    const pcs = this.props.params.priceConditions.reverse()
    const l = pcs.length
    if(l == 0)
      return null

    return (
      <div className="item-price-conds">
        { pcs.map((it, ind)=>
          (
            <span key={ind}>
              от { it.quantity } &mdash;

              <CurFormatComponent price={it.price}/>
              { (l != ind + 1) &&
                <span>, </span>
              }
            </span>
          )
        ) }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/item_price_conditions/item_price_conditions.component.jsx